import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

const Whychooseusa = () => {
  return (
    <div className="whychooseusa p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={10}
            lg={10}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <h2>
              <span>Why Choose Us</span> as Your Trusted Flutter Application
              Development Company?
            </h2>
          </Col>
        </Row>
        <Row className="h-100 choose_padd">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
            <p>
              Wondering why we stand out for strategic collaboration? It's
              because we convert concepts into full-fledged Flutter apps
            </p>
            <p>
              Here's why you should choose us as your reliable Flutter mobile
              application development company:
            </p>
            <ul>
              <li>
                <strong>Expertise & Experience:</strong> Our Flutter developers
                bring a wealth of expertise, navigating the complexities of the
                framework to craft smooth and efficient mobile applications.
              </li>
              <li>
                <strong>Communication:</strong> We use agile techniques and
                transparent communication for real-time insights, fostering
                collaborative development engagement.
              </li>
              <li>
                <strong>Scalability:</strong> We ensure smooth Flutter app
                growth using scalable architectures, cloud technology, and
                optimal performance.
              </li>
              <li>
                <strong>Technical Proficiency:</strong> Our developers excel in
                cutting-edge frameworks, showcasing technical mastery for
                complex Flutter app projects.
              </li>
              <li>
                <strong>Cost-Effectiveness:</strong> We maximize efficiency
                through coding and agile workflows, ensuring cost-effectiveness
                without compromising Flutter app quality.
              </li>
            </ul>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Schedule A Free Consultation Session
            </Link>
          </Col>
          <Col xs={12} md={6} lg={7} xl={7} xxl={7}>
            <StaticImage
              src="../../images/services-usa/flutter/Why-Choose.webp"
              alt="Flutter Application Development Company"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={993}
              height={832}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Whychooseusa;
